<template>
    <div class="Desktop">
        DESKTOP !
    </div>
</template>

<script> 

import Mixin from '@/mixins/Smooth.js'
import gsap from "gsap"


export default {
    name: 'Desktop',
    mixins: [Mixin],
    components: {  },
    data: () => ({
        width: window.innerWidth,
        height: window.innerHeight,
    }),

    methods: {  
        getLang() {
            return this.lang == 'fr' ? 'EN' : 'FR'
        }
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'
@import '~@/commons/stylus/Hamburger-icon'

.Desktop 
    display flex
           
</style>


